module.exports = __webpack_public_path__ + "static/media/icon_linkedin.8105652c.svg";